import { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import useGetSpecialFunctionsDropdown from '../../screens/Units/hooks/useGetSpecialFunctionsDropdown';
import DropdownInput from '../DropdownInput';

const SpecialFunctionsDropdown = (props) => {
  const {
    unitId,
    useLabel = true,
    placeholder,
    forceinitialvalue,
    required = true,
    isClearable = false,
    existingSpecialFunctionIds = []
  } = props;

  const { specialFunctions, isFetching } = useGetSpecialFunctionsDropdown();

  const [resetValue, setResetValue] = useState(Date.now());
  const resetDropdown = () => {
    setResetValue(Date.now());
  };

  useEffect(() => {
    if (!isFetching) {
      resetDropdown();
    }
  }, [isFetching, props?.options?.length]);

  return (
    <>
      <DropdownInput
        {...props}
        key={resetValue}
        isLoading={isFetching}
        label={useLabel ? props.label || <FormattedMessage id="units.specialFunctions" /> : null}
        options={
          props.options ||
          specialFunctions
            .filter(
              (specialFunction) =>
                !existingSpecialFunctionIds.includes(specialFunction.specialFunctionId)
            )
            .map((specialFunction) => ({
              id: specialFunction.specialFunctionId,
              value: specialFunction.specialFunctionId,
              label: (
                <FormattedMessage
                  id={`units.specialFunction${specialFunction.specialFunctionId}`}
                />
              ),
              label_intl: useIntl().formatMessage({
                id: `units.specialFunction${specialFunction.specialFunctionId}`
              })
            }))
        }
        placeholder={
          placeholder ??
          useIntl().formatMessage({
            id: 'common.all'
          })
        }
        forceinitialvalue={forceinitialvalue}
        required={required}
        isClearable={isClearable}
        isDisabled={props.isDisabled}
      />
    </>
  );
};

export default SpecialFunctionsDropdown;
